module.exports = __webpack_public_path__ + "media/dog-weight/german-shepherd-white-13389fbf.svg";